module.exports = __webpack_public_path__ + "static/media/listen_spotify.acc5c718.png";